import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useBul } from "./BulLayout";
import FacilitiesGrid from "@/components/FacilitiesGrid";

export default function Facilities() {
  const data = useBul();
  const items = data?.facilities || [];
  return (
    <div data-testid="bul-facilities">
      <PageHero eyebrow="Campus" title="World-class Facilities" />
      <PageBody>
        <FacilitiesGrid
          items={items}
          testidPrefix="bul-facilities"
          cardClassName="bg-white border border-[#D9D2C1] overflow-hidden hover:shadow-md transition-shadow"
          accentChipClass="bg-[#FDBB30] text-[#0F0F10] font-semibold"
        />
      </PageBody>
    </div>
  );
}
